module.exports = __webpack_public_path__ + "static/media/Brand Infographic Mobile 29-02-2024  .a99f5595.gif";